import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import css from '../../../css/group/room/member.module.scss';
import { ReactComponent as Mice } from '../../../img/common/mice.svg';
import { ReactComponent as MuteMice } from '../../../img/common/muteMice.svg';
import { ReactComponent as Slider } from '../../../img/common/slider.svg';
import { Voice } from '../../../model/Voice';
import { Member as MemberModel } from '../../../model/member';
import { selectUser } from '../../../slice/userSlice';
import { setOutputVolumeOfMember } from '../../../slice/voiceCallSlice';
import { MyPopup } from '../../common/myPopup';
import { MySlider } from '../../common/mySlider';

type MemberProps = {
    member: MemberModel & Voice;
};

export const Member: React.FC<MemberProps> = (props) => {
    const dispatch = useDispatch();
    const { entity: user } = useSelector(selectUser);

    const controlPopup = (
        <div className={css.popup}>
            <p>{props.member.name}の出力通話音量</p>
            <MySlider
                onChange={(val) => {
                    dispatch(
                        setOutputVolumeOfMember({
                            memberId: props.member.id,
                            volume: val,
                        })
                    );
                }}
                defaultValue={props.member.outputVolume}
            />
        </div>
    );

    const borderClass = props.member.isTalking ? css.imgBorder : '';
    return (
        <div className={css.content}>
            <img src={props.member.icon} alt="" className={borderClass} />
            <p>{props.member.name}</p>
            {user?.id !== props.member.id && (
                <>
                    {props.member.isMute ? (
                        <MuteMice height={24} width={24} role="img" aria-label="ミュート中" fill={'#D1D1D6'} />
                    ) : (
                        <Mice height={24} width={24} fill="#F14D38" role="img" aria-label="" />
                    )}

                    <MyPopup
                        trigger={<Slider height={24} width={24} fill="#8E8E93" role="img" aria-label="音量調整" />}
                        title="個別音量調整"
                        content={controlPopup}
                    />
                </>
            )}
        </div>
    );
};
